import React from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import ListView from "../../../components/listView/ListView";
import studentListViewMeta from "../../../configs/meta/listViewMeta/studentListViewMeta";

const Students = () => (
  <React.Fragment>
    <Helmet title="Students Page" />
    <Container fluid className="p-0">
      <ListView meta={studentListViewMeta()} title="Students List" />
    </Container>
  </React.Fragment>
);

export default Students;
